import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Button, Spinner } from 'reactstrap';
import QRCode from 'react-qr-code';
import { LI } from '../../../AbstractElements';
import { BsQrCodeScan } from 'react-icons/bs';
import { Download, Share2 } from 'react-feather';
import { toast } from 'react-toastify';
import { serviceRequestQrUrl, getClientUrlDataToken, getMasterDataToken, importURL, postClientUrlWithToken } from '../../../Utils/restUtils';
import { getEncodedCompany } from '../../../CommonUrl';
import axios from 'axios';
import html2canvas from 'html2canvas';
import iamge from '../../../assets/images/Icons/Newbadge.gif'


const QrCodeModal = () => {
    const [modal, setModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [encodedCode, setEncodedCode] = useState('');
    const [loadingQr, setLoadingQr] = useState(false);
    const authState = useSelector((state) => state.auth);

    const toggle = () => {
        setModal(!modal);
        setCopied(false);
    };

    const companyId = authState?.companyId || authState?.subStatus?.company_id || '';
    const companyName = authState?.companyName || 'SERVICE SUPPORT';

    useEffect(() => {
        if (companyId && modal) {
            fetchEncodedCompanyCode();
        }
    }, [companyId, modal]);

    const fetchEncodedCompanyCode = async () => {
        setLoadingQr(true);
        try {
            let response;
            if (authState?.apiUrl) {
                response = await postClientUrlWithToken(authState.apiUrl, `${getEncodedCompany}?company_id=${companyId}`);
            }


            const code = response?.data.data;
            if (code) {
                setEncodedCode(code);
            } else {
                setEncodedCode(companyId);
            }
        } catch (error) {
            console.error("Error fetching encoded company code:", error);
            setEncodedCode(companyId);
        } finally {
            setLoadingQr(false);
        }
    };

    const activeCode = encodedCode || companyId;
    const qrUrl = `${serviceRequestQrUrl}${activeCode}`;

    const handleCopy = () => {
        if (qrUrl) {
            navigator.clipboard.writeText(qrUrl);
            setCopied(true);
            toast.success('Link copied to clipboard!');
            setTimeout(() => setCopied(false), 2000);
        }
    };

    const handleDownload = async () => {
        const cardElement = document.getElementById("service-request-qr-card");
        if (!cardElement) return;

        setDownloading(true);
        try {
            const canvas = await html2canvas(cardElement, {
                scale: 3,
                useCORS: true,
                backgroundColor: null,
                logging: false,
            });

            const pngFile = canvas.toDataURL("image/png");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngFile;
            downloadLink.download = `${companyName.replace(/\s+/g, '_')}_Service_Request_QR.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            toast.success('Service Request QR downloaded successfully!');
        } catch (error) {
            console.error('Download error:', error);
            toast.error('Failed to download QR code');
        } finally {
            setDownloading(false);
        }
    };

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: `${companyName} - Service Request Portal`,
                    text: 'Scan QR code to submit a repair or service request',
                    url: qrUrl,
                });
            } catch (err) {
                if (err.name !== 'AbortError') {
                    handleCopy();
                }
            }
        } else {
            handleCopy();
        }
    };

    return (
        <Fragment>
            {/* <div > */}
            <LI attrLI={{ className: 'maximize p-2 cursor-pointer' }}>
                <a
                    className="text-dark d-flex align-items-center"
                    href="#javascript"
                    onClick={toggle}
                    title="Service Request QR Code"
                    style={{ fontSize: '18px', cursor: 'pointer',position:'relative' }}
                >
                    <BsQrCodeScan size={20} />
                </a>

            <span style={{ position: 'absolute', bottom: '23px',  }}>
                <img style={{ width: '42px' }} src={iamge} alt="" />
            </span>
            </LI>
            {/* </div> */}

            <Modal isOpen={modal} toggle={toggle} centered size="md">
                <ModalHeader toggle={toggle}>
                    Service Request Portal QR
                </ModalHeader>
                <ModalBody className="p-3">
                    {companyId ? (
                        <div className="d-flex flex-column align-items-center">
                            {/* Printable Poster Card */}
                            <div
                                id="service-request-qr-card"
                                style={{
                                    background: 'linear-gradient(135deg, #0b5ed7 0%, #003882 100%)',
                                    padding: '18px',
                                    borderRadius: '14px',
                                    width: '100%',
                                    maxWidth: '300px',
                                    boxShadow: '0 8px 20px rgba(0, 86, 179, 0.22)',
                                    color: '#1e293b'
                                }}
                            >
                                <div
                                    style={{
                                        backgroundColor: '#ffffff',
                                        borderRadius: '10px',
                                        padding: '18px 14px',
                                        textAlign: 'center',
                                        boxShadow: '0 4px 10px rgba(0,0,0,0.06)'
                                    }}
                                >
                                    {/* Company Name Badge */}
                                    <div
                                        style={{
                                            backgroundColor: '#0b5ed7',
                                            color: '#ffffff',
                                            padding: '4px 12px',
                                            borderRadius: '16px',
                                            display: 'inline-block',
                                            fontWeight: '700',
                                            fontSize: '11px',
                                            letterSpacing: '0.8px',
                                            textTransform: 'uppercase',
                                            marginBottom: '12px'
                                        }}
                                    >
                                        {companyName}
                                    </div>

                                    {/* Headline */}
                                    <h6
                                        style={{
                                            color: '#0f172a',
                                            fontWeight: '800',
                                            fontSize: '13px',
                                            lineHeight: '1.35',
                                            textTransform: 'uppercase',
                                            marginBottom: '12px',
                                            letterSpacing: '0.4px'
                                        }}
                                    >
                                        NEED TO REPORT A REPAIR OR MAINTENANCE?
                                    </h6>

                                    <div style={{ fontWeight: '700', fontSize: '11px', color: '#0b5ed7', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>
                                        Scan
                                    </div>

                                    {/* QR Code Container with Corner Frame Accents */}
                                    <div className="d-flex justify-content-center my-1">
                                        <div
                                            style={{
                                                position: 'relative',
                                                padding: '10px',
                                                backgroundColor: '#ffffff',
                                                borderRadius: '8px',
                                                minHeight: '165px',
                                                minWidth: '165px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {/* Corner brackets */}
                                            <div style={{ position: 'absolute', top: '2px', left: '2px', width: '14px', height: '14px', borderTop: '2px solid #00d2ff', borderLeft: '2px solid #00d2ff' }}></div>
                                            <div style={{ position: 'absolute', bottom: '2px', right: '2px', width: '14px', height: '14px', borderBottom: '2px solid #00d2ff', borderRight: '2px solid #00d2ff' }}></div>

                                            {loadingQr ? (
                                                <div className="p-3 text-center">
                                                    <Spinner color="primary" size="sm" />
                                                </div>
                                            ) : (
                                                <QRCode
                                                    id="company-qr-code-svg"
                                                    value={qrUrl}
                                                    size={145}
                                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                    viewBox={`0 0 256 256`}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <p style={{ fontSize: '11px', color: '#64748b', marginTop: '10px', marginBottom: '4px', fontWeight: '500' }}>
                                        Scan QR code to submit your request online instantly
                                    </p>
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="d-flex gap-2 justify-content-center w-100 mt-3" style={{ maxWidth: '300px' }}>
                                <Button
                                    color="primary"
                                    size="sm"
                                    className="d-flex align-items-center gap-1 flex-grow-1 justify-content-center"
                                    onClick={handleDownload}
                                    disabled={downloading || loadingQr}
                                >
                                    {downloading ? (
                                        <>
                                            <Spinner size="sm" style={{ width: '14px', height: '14px' }} />
                                            Downloading...
                                        </>
                                    ) : (
                                        <>
                                            <Download size={14} />
                                            Download
                                        </>
                                    )}
                                </Button>
                                <Button
                                    color="info"
                                    size="sm"
                                    className="text-white d-flex align-items-center gap-1 flex-grow-1 justify-content-center"
                                    onClick={handleShare}
                                    disabled={loadingQr}
                                >
                                    <Share2 size={14} />
                                    Share Link
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <p className="text-danger my-3">Company ID not found. Please log in again.</p>
                    )}
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default QrCodeModal;
